import Vue from 'vue';
import News from './news.vue';
Vue.component('news', News);
